import { ME_UPDATE, ME_REPLACE } from 'actions/me'

const initialState = null

export default (state = initialState, action) => {
  switch (action.type) {
    case ME_UPDATE: {
      return action.me
    }

    case ME_REPLACE: {
      return action.me
    }

    default:
      return state
  }
}
